import { API_ENDPOINTS } from '../api/config';

let cachedLeaderboard = null;
let cachedLeaderboardKey = null;
let leaderboardPromise = null;

const isLocalhost = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return ['localhost', '127.0.0.1'].includes(window.location.hostname);
};

const buildMockLeaderboard = (currentUserName = '') => {
  const normalizedCurrentUserName = String(currentUserName || '').trim();

  const mockNames = [
    'Dev Admin User',
    'Ava Martinez',
    'Noah Chen',
    'Sophia Johnson',
    'Liam Patel',
    'Emma Rodriguez',
    'Olivia Brown',
    'Ethan Wilson',
    'Mia Thompson',
    'Lucas Garcia',
    'Isabella Anderson',
    'Mason Lee',
    'Amelia Taylor',
    'Elijah Moore',
    'Harper Jackson',
    'Logan White',
    'Evelyn Harris',
    'James Martin',
    'Charlotte Clark',
    'Benjamin Lewis',
    'Sofia Walker',
    'Henry Hall',
    'Aria Young',
    'Jack Allen',
    'Scarlett King',
    'Owen Wright',
    'Luna Scott',
    'Wyatt Green',
    'Layla Adams',
    'Caleb Baker'
  ];

  const mockUsers = mockNames.map((name, index) => {
    const totalPoints = Math.max(28, 180 - (index * 4));
    const totalMinutes = totalPoints * 30;
    const currentStreakDays = Math.max(1, 24 - Math.floor(index / 2));
    const longestStreakDays = currentStreakDays + (index % 4);

    return {
      name,
      totalPoints,
      totalMinutes,
      currentStreakDays,
      longestStreakDays,
      badgesEarned: Math.max(2, Math.floor(totalPoints / 10))
    };
  });

  return mockUsers.map((user, index) => ({
    rank: index + 1,
    displayName: `${user.name.slice(0, 2)}…`,
    totalPoints: user.totalPoints,
    totalMinutes: user.totalMinutes,
    hoursStudied: Number((user.totalMinutes / 60).toFixed(1)),
    currentStreakDays: user.currentStreakDays,
    longestStreakDays: user.longestStreakDays,
    badgesEarned: user.badgesEarned,
    isCurrentUser: normalizedCurrentUserName.length > 0 && user.name === normalizedCurrentUserName,
    fullName: user.name
  }));
};

const getCacheKey = (currentUserName = '') => {
  if (isLocalhost()) {
    return `mock:${String(currentUserName || '').trim()}`;
  }

  return 'remote';
};

export const getStudyLeaderboard = async (currentUserName = '') => {
  const cacheKey = getCacheKey(currentUserName);

  if (cachedLeaderboard && cachedLeaderboardKey === cacheKey) {
    return cachedLeaderboard;
  }

  if (leaderboardPromise && cachedLeaderboardKey === cacheKey) {
    return leaderboardPromise;
  }

  if (isLocalhost()) {
    const mockLeaderboard = buildMockLeaderboard(currentUserName);
    cachedLeaderboard = mockLeaderboard;
    cachedLeaderboardKey = cacheKey;
    return mockLeaderboard;
  }

  leaderboardPromise = (async () => {
    const response = await fetch(API_ENDPOINTS.STUDY_LEADERBOARD, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch leaderboard: ${response.status}`);
    }

    const data = await response.json();
    cachedLeaderboard = Array.isArray(data.leaderboard) ? data.leaderboard : [];
    cachedLeaderboardKey = cacheKey;
    return cachedLeaderboard;
  })()
    .catch((error) => {
      cachedLeaderboard = null;
      cachedLeaderboardKey = null;
      throw error;
    })
    .finally(() => {
      leaderboardPromise = null;
    });

  return leaderboardPromise;
};

export const prefetchStudyLeaderboard = (currentUserName = '') => {
  void getStudyLeaderboard(currentUserName).catch(() => {
    // Ignore background prefetch failures; the modal will surface errors if needed.
  });
};
